import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapToKeys'
})
export class MapToKeysPipe implements PipeTransform {

  transform(objArr) {
	console.log('obj array looks like this: ', objArr);
	const mappingObject = {};
	objArr.forEach((obj) => {
		for (const key in obj) {
		const value = obj[key];
		mappingObject[key] = value;
		}
	});
	return mappingObject;
  }

}
